import { View } from 'react-native'
import { SvgXml } from 'react-native-svg'
import { unfreezeSource } from './unfreeze-source'
import { useCreateStyles } from './unfreeze-styles'

export function AppIconUnfreeze({ size = 24, color, testID }: { size?: number; color?: string; testID?: string }) {
  const styles = useCreateStyles()
  const xml = color ? unfreezeSource.replace(/#F1F1F3/g, color) : unfreezeSource
  return (
    <View testID={testID} style={[styles.icon, { width: size, height: size }]}>
      <SvgXml xml={xml} />
    </View>
  )
}
